import React, { useState } from 'react';
import { Guid } from '@Shared.Angular/@types/guid';
import FlowStepTagsModal from './FlowStepTags/FlowStepTagsModal';
import { getService } from '@Client/runner.hooks/useService';

type Props = {
  stepName: string;
  stepTagIds: Guid[];
};

const FlowStepTagsIcon = ({ stepName, stepTagIds }: Props) => {
  const [open, setOpen] = useState(false);
  const { enableTagging } = getService('APP_CONFIG');

  if (!enableTagging || !stepTagIds.length) return null;

  const handleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <span
        className="far fa-tag fa-flip-horizontal flow-step-tags-icon-container"
        onClick={handleOpen}
      ></span>
      {open && (
        <FlowStepTagsModal
          stepName={stepName}
          stepTagIds={stepTagIds}
          onClose={handleClose}
        />
      )}
    </>
  );
};

export default FlowStepTagsIcon;
